var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.28487 13.7196C9.54857 13.7196 9.76977 13.6302 9.94847 13.4515C10.1265 13.2734 10.2156 13.0526 10.2156 12.7889C10.2156 12.5251 10.1265 12.3039 9.94847 12.1253C9.76977 11.9472 9.54857 11.8581 9.28487 11.8581C9.02117 11.8581 8.80028 11.9472 8.6222 12.1253C8.4435 12.3039 8.35416 12.5251 8.35416 12.7889C8.35416 13.0526 8.4435 13.2734 8.6222 13.4515C8.80028 13.6302 9.02117 13.7196 9.28487 13.7196ZM8.35416 9.99671H10.2156V4.41243H8.35416V9.99671ZM5.79469 17.4424L0.908447 12.5562V5.57582L5.79469 0.689575H12.775L17.6613 5.57582V12.5562L12.775 17.4424H5.79469ZM6.5858 15.581H11.9839L15.7999 11.7651V6.36693L11.9839 2.551H6.5858L2.76987 6.36693V11.7651L6.5858 15.581Z",
    fill: "#D5476B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.36113b1cb8c2626445d17962f6a927b7.svg";
export { ForwardRef as ReactComponent };